import React from "react";
import "./banneroferta.css";
import { useQuery } from "react-query";
import {getData} from "../../Helpers/getData";
import { Link } from "react-router-dom";

export default function Banneroferta() {

  const { status } = useQuery("sheet", getData);

  if(status === 'loading'){
    return false;
  }

  return (
    <div className="container-banner-oferta">
      <div className="banner" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/img/bgbanner.jpg'})` }}>
        <div className="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40.08"
            height="36.674"
            viewBox="0 0 40.08 36.674"
          >
            <g id="offer" transform="translate(-1.2 -3.862)">
              <path
                id="Trazado_29"
                data-name="Trazado 29"
                d="M39.781,19.137,38.217,17.9a1.6,1.6,0,0,1-.587-1.629l.521-1.955a3.893,3.893,0,0,0-.587-3.258,4.1,4.1,0,0,0-3.128-1.694l-2.085-.13a1.842,1.842,0,0,1-1.564-1.043l-.782-1.825a4.276,4.276,0,0,0-2.476-2.281,4.174,4.174,0,0,0-3.519.391L22.25,5.516a1.776,1.776,0,0,1-1.955,0l-1.76-1.043a4.174,4.174,0,0,0-3.519-.391A4.082,4.082,0,0,0,12.54,6.363l-.782,1.825a1.728,1.728,0,0,1-1.564,1.043l-2.085.13A4.213,4.213,0,0,0,4.98,11.056a3.893,3.893,0,0,0-.587,3.258l.521,1.955A1.488,1.488,0,0,1,4.328,17.9L2.7,19.137a3.879,3.879,0,0,0,0,6.126L4.328,26.5a1.6,1.6,0,0,1,.587,1.629l-.521,1.955a3.893,3.893,0,0,0,.587,3.258,4.1,4.1,0,0,0,3.128,1.694l2.085.13a1.842,1.842,0,0,1,1.564,1.043l.782,1.825a4.276,4.276,0,0,0,2.476,2.281,4.516,4.516,0,0,0,1.3.2,4.1,4.1,0,0,0,2.151-.587l1.76-1.043a1.776,1.776,0,0,1,1.955,0l1.76,1.043a4.174,4.174,0,0,0,3.519.391,4.082,4.082,0,0,0,2.476-2.281l.782-1.825a1.728,1.728,0,0,1,1.564-1.043l2.085-.13A4.213,4.213,0,0,0,37.5,33.344a3.893,3.893,0,0,0,.587-3.258l-.521-1.955a1.488,1.488,0,0,1,.587-1.629l1.629-1.238a3.879,3.879,0,0,0,0-6.126Zm-1.369,4.3-1.629,1.238a3.867,3.867,0,0,0-1.369,4.041l.521,1.955a1.366,1.366,0,0,1-.261,1.3,1.7,1.7,0,0,1-1.369.717l-2.085.13A3.985,3.985,0,0,0,28.7,35.3l-.782,1.89a1.907,1.907,0,0,1-2.737.782l-1.76-1.043a4.356,4.356,0,0,0-4.366,0l-1.694,1.043a2.3,2.3,0,0,1-1.629.2,1.845,1.845,0,0,1-1.108-.978l-.782-1.825a4.1,4.1,0,0,0-3.519-2.476l-2.085-.13A1.884,1.884,0,0,1,6.87,32.04a1.561,1.561,0,0,1-.261-1.3l.521-1.955a3.867,3.867,0,0,0-1.369-4.041L4.133,23.5a1.679,1.679,0,0,1-.652-1.238,1.411,1.411,0,0,1,.652-1.238l1.629-1.238A3.867,3.867,0,0,0,7.13,15.748l-.521-1.955a1.366,1.366,0,0,1,.261-1.3,1.7,1.7,0,0,1,1.369-.717l2.085-.13a3.985,3.985,0,0,0,3.519-2.476l.782-1.955a1.845,1.845,0,0,1,1.108-.978,1.9,1.9,0,0,1,.587-.13,1.7,1.7,0,0,1,.978.261l1.76,1.043a4.356,4.356,0,0,0,4.366,0l1.76-.978a2.3,2.3,0,0,1,1.629-.2,1.845,1.845,0,0,1,1.108.978L28.7,9.035a4.1,4.1,0,0,0,3.519,2.476l2.085.13a1.884,1.884,0,0,1,1.369.717,1.561,1.561,0,0,1,.261,1.3l-.521,1.955a3.867,3.867,0,0,0,1.369,4.041L38.412,20.9a1.679,1.679,0,0,1,.652,1.238A1.6,1.6,0,0,1,38.412,23.438Z"
                transform="translate(0 0)"
                fill="#fff"
              />
              <path
                id="Trazado_30"
                data-name="Trazado 30"
                d="M34.578,22.617a1.141,1.141,0,0,0-1.629,0l-10.232,10.3a1.141,1.141,0,0,0,0,1.629,1.1,1.1,0,0,0,1.564,0l10.3-10.3A1.141,1.141,0,0,0,34.578,22.617Z"
                transform="translate(-7.375 -6.413)"
                fill="#fff"
              />
              <circle
                id="Elipse_1"
                data-name="Elipse 1"
                cx="2.542"
                cy="2.542"
                r="2.542"
                transform="translate(14.43 15.357)"
                fill="#fff"
              />
              <circle
                id="Elipse_2"
                data-name="Elipse 2"
                cx="2.542"
                cy="2.542"
                r="2.542"
                transform="translate(23.032 23.894)"
                fill="#fff"
              />
            </g>
          </svg>
        </div>
        <h2>¡PRODUCTOS<br></br>EN OFERTA!</h2>
        <p>Descubrí descuentos especiales.</p>
        <Link to={"/ofertas"}>
          <button className="button button-line">Ver ofertas</button>
        </Link>
      </div>
    </div>
  );
}
